import { APIGet, APIPost, APIPut, APIDelete, IAPIResponse } from "api/protocols";
import { CancelToken } from "axios";

const apiVersion = "2024-04";
const adminType = "facility-admin";
const baseUrl = "/" + apiVersion + "/" + adminType + "/facility/power-cart";

interface IGetPowerCart {
  id?: number;
  status?: string[];
  offset?: number;
  limit?: number;
}

export interface IPowerCart {
  brand: string;
  eighteen_hole_time: string;
  facility_id: number;
  id: number;
  maintenance_time: string;
  name: string;
  nine_hole_time: string;
  notes: string;
  status: string;
  type: string;
  available_at: string;
  seats_available: number;
}

// GET Power carts
export async function GetPowerCarts(params: IGetPowerCart, useGlobalLoader: boolean, cancelToken?: CancelToken) {
  return await APIGet<IPowerCart[]>(baseUrl, params, useGlobalLoader, cancelToken);
}

interface IPostPowerCart {
  amount: number;
  name: string;
  brand: string;
  type: string;
  starting_number: number;
}

// POST Power carts
export async function PostPowerCarts(params: IPostPowerCart, useGlobalLoader: boolean) {
  return await APIPost(baseUrl, params, useGlobalLoader);
}

interface IPutPowerCart {
  id: number;
  name?: string;
  brand?: string;
  status?: string;
  type?: string;
  notes?: string;
}

// PUT Power carts
export async function PutPowerCart(params: IPutPowerCart, useGlobalLoader: boolean) {
  return await APIPut(baseUrl, params, useGlobalLoader);
}

interface IDeletePowerCart {
  id: number;
}

// DELETE Power carts
export async function DeletePowerCart(params: IDeletePowerCart, useGlobalLoader: boolean) {
  return await APIDelete(baseUrl, params, useGlobalLoader);
}


export async function ExportPowerCartPDF(params: { emails: Array<string> }, useGlobalLoader: boolean) {
  return await APIPost(baseUrl + "/export", params, useGlobalLoader);
}

export async function GetPowerCartAudits(
  params: { power_cart_id: number; offset?: number; limit?: number },
  useGlobalLoader: boolean,
  cancelToken?: CancelToken,
): Promise<IAPIResponse<IPowerCart[]>> {
  return await APIGet<IPowerCart[]>(baseUrl + "/audits", params, useGlobalLoader, cancelToken);
}

export async function GetPowerCartAuditTrailExport(
  params: { power_cart_id: number, date_range_start: Date, date_range_end: Date },
  useGlobalLoader: boolean,
) {
  return await APIGet(baseUrl + "/audit-trail", params, useGlobalLoader);
}
